import { render, staticRenderFns } from "./ResultTabs.vue?vue&type=template&id=6d8926c6&scoped=true"
import script from "./ResultTabs.vue?vue&type=script&lang=js"
export * from "./ResultTabs.vue?vue&type=script&lang=js"
import style0 from "./ResultTabs.vue?vue&type=style&index=0&id=6d8926c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8926c6",
  null
  
)

export default component.exports